function showLoadingOverlay(delay) {
    if (delay === undefined) {
        delay = 10;
    }
    var overlay = $('<div class="loading"></div>');
    overlay.appendTo(document.body);
    setTimeout(function () {
        $('.loading').remove();
    }, delay * 1000);
}

$(function(){
    // $(".fancybox").fancybox({
    //     openEffect	: 'none',
    //     closeEffect	: 'none',
    //     afterShow: function () {
    //         console.log('Showed');
    //         var image = $('.fancybox-image').attr('src');
    //         $('.fancybox-inner').append('<span class="fullsize"><a href="'+image+'" target="_blank"><i class="fa fa-arrows-alt" aria-hidden="true"></i></a></span>');
    //     },
    //     onComplete: function () {
    //         console.log('COmplete');
    //         var image = $('.fancybox-image').attr('src');
    //         $('.fancybox-inner').append('<span class="fullsize"><a href="'+image+'" target="_blank"><i class="fa fa-arrows-alt" aria-hidden="true"></i></a></span>');
    //     }
    // });


    $(document).on('pjax:complete', function() {
        $('.loading').remove();
    });

    // Add/Remove favorites
    $('#fav-button').on('click', function(){
        var data = $(this).data();
        var url = '/'+data['controller']+'/favorite';
        /*if(data['language'] !== 'en'){
            url = '/'+data['language'] + url;
        }*/

        $.post(url, data).done(function( data ) {
                $('#fav-button').html(data);
            });
    });

    // Rating
    $('body').on('click', '#rating li, #rating-big li', function(){
        var big = false;
        if($("div").is("#rating-big")){
            big = true;
        }

        $(this).closest("div").find(".rating-spin").html("<i class='fa fa-circle-o-notch fa-spin'></i>");

        var rank = $(this).children('a').data('rank');
        var data = $(this).parent('ol').data();
        data['rank'] = rank;

        var url = '/site/rank';
        /*if(data['language'] !== 'en'){
            url = '/'+data['language'] + url;
        }*/

        var clickedElement = $(this);

        $.post(url , data)
            .done(function( data ) {
                //console.log(data);
                var result = data.result;
                var html = data.html;
                if(html){
                    clickedElement.closest('.rating').html(html);
                }
                if(big){
                    $(".rating-spin").html(result);
                } else {
                    $(".rating-spin").html('');
                    swal(result);
                }
            });

    });

    // 4 items, autoplay (celebrities, world charts)
    var owl4 = $('.owl-carousel-4');
    owl4.owlCarousel({
        items:4,
        loop:true,
        margin:10,
        navigation:true,
        pagination:false,
        autoPlay:3000,
        stopOnHover:true
        //autoPlayTimeout:500,
        //autoPlayHoverPause:false
    });

    // 3 items, no autoplay (pics, clips, sextapes)
    var owl3 = $('.owl-carousel-3');
    owl3.owlCarousel({
        items:3,
        loop:true,
        margin:10,
        navigation:true,
        pagination:false
    });

    // Hover on small images in appearance listing
    /*$('.img-small').hover(function(){
        var id = $(this).data('id');
        $('#img-'+id).show();
    }, function(){
        var id = $(this).data('id');
        $('#img-'+id).hide();
    });*/

    $(document).on({
        mouseenter: function () {
            var id = $(this).data('id');
            $('#img-'+id).show();
        },
        mouseleave: function () {
            var id = $(this).data('id');
            $('#img-'+id).hide();
        }
    }, ".img-small");

    $(document).on('click', '.contrib-collapse', function () {
        var icon = $('.contrib-collapse').parents('.panel-title').find('i');
        if($('#collapse1').attr('aria-expanded') === 'true'){
            icon.removeClass('fa-plus-square-o').addClass('fa-minus-square-o');
        } else {
            icon.removeClass('fa-minus-square-o').addClass('fa-plus-square-o');
        }
    });
});
